import { imgDomain } from "../configs/env";

export const imgFilter = (value) => imgDomain + value;
